import { useState } from "react";
import ReactPasswordChecklist from "react-password-checklist";
import { toast } from "react-toastify";
import axiosInstance from "../../../hooks/axiosInstance";
import Loader from "../../utilities/Loader/Loader";

export default function AssociationAdminChangePassword() {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: ''
  })

  const [toggle, setToggle] = useState(false)
  const [toggleConfirm, setToggleConfirm] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [validationError, setValidationError] = useState({})

  const handleChange = (e) => {
    const {name, value} = e.target

    setFormData(prevFormData => (
      {...prevFormData, [name]: value}
    ))
  }

  const handleToggle = () =>{
      setToggle(!toggle)
  }

  const handleConfirmToggle = () =>{
      setToggleConfirm(!toggleConfirm)
  } 

  const resetFormData = () => {
    setFormData({
      current_password: '',
      new_password: '',
      new_password_confirmation: ''
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if(formData.new_password !== formData.new_password_confirmation){
        toast.error("Password do not match")
        return
    }
    setSubmitLoading(true)
    setValidationError({})
    axiosInstance.post('/association/change-password', formData)
        .then(res => {
            toast.success("Password updated Succesfully")
            resetFormData()
        })
        .catch(err => {
            toast.error("An error occured. Please, try again")
            if(err.response.status == 422) {
                setValidationError(err.response.data.errors)
            }
        })
        .finally(() => setSubmitLoading(false))
}
  

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-lg-12 mb-4">
          <div>
            <label htmlFor="oldpasswordInput" className="form-label">
              Old Password*
            </label>
            <input
              type="password"
              className="form-control"
              id="oldpasswordInput"
              name="current_password"
              value={formData.current_password}
              onChange={handleChange}
              placeholder="Enter current password"
            />
            {validationError.current_password && (<small className="text-danger mt-1 mb-0">{validationError.current_password[0]}</small>)}
          </div>
        </div>
        <div className="col-lg-12 mb-4">
          <div>
            <label htmlFor="newpasswordInput" className="form-label">
              New Password*
            </label>
            <div className="position-relative auth-pass-inputgroup">
              <input
                type={toggle ? `text` : `password`}
                className="form-control"
                id="newpasswordInput"
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
              <button
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                  type="button" onClick={handleToggle}
              >
                  <i className={`${toggle ? 'ri-eye-off-fill' : 'ri-eye-fill'} align-middle`}></i>
              </button>
            </div>
            {formData.new_password && (
                <ReactPasswordChecklist
                    className="p-3 bg-light mb-2 mt-2 rounded"
                    rules={[
                        "minLength",
                        "specialChar",
                        "number",
                        "capital",
                        "match",
                    ]}
                    minLength={5}
                    value={formData.new_password}
                    valueAgain={formData.new_password_confirmation}
                />
            )}
          </div>
        </div>
        <div className="col-lg-12 mb-4">
          <div>
            <label htmlFor="confirmpasswordInput" className="form-label">
              Confirm Password*
            </label>
            <div className="position-relative auth-pass-inputgroup">
              <input
                type={toggleConfirm ? `text` : `password`}
                className="form-control"
                id="confirmpasswordInput"
                name="new_password_confirmation"
                value={formData.new_password_confirmation}
                onChange={handleChange}
                placeholder="Confirm password"
              />
              <button
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                  type="button" onClick={handleConfirmToggle}
              >
                  <i className={`${toggleConfirm ? 'ri-eye-off-fill' : 'ri-eye-fill'} align-middle`}></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-12 mt-3">
          <div className="hstack gap-2 justify-content-end">
            <button type="submit" className="btn btn-primary">
              Change Password
            </button>
            {/* <button type="button" className="btn btn-soft-success">
              Cancel
            </button> */}
          </div>
        </div>
      </div>
      {submitLoading && <Loader />}
    </form>
  );
}
